/* eslint-disable import/no-anonymous-default-export */
import Workflows from "./Workflows";
import Placeholders from "./Placeholders";
export default {
    id: 111,
    title: 'Records',
    path: 'records',
    icon: "flaticon2-writing",
    workflows: Workflows,
    placeholders: Placeholders,
};